import MainLayout from "@/components/layout/MainLayout.vue";
import moment from 'moment';
import axios from "axios";
import { mapGetters } from "vuex";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: "newsDetail",

    components: {
        MainLayout
    },

    data() {
        return {
            news: {
                news_id: "",
                news_title: "",
                news_details: "",
                publish_date: ""
            },
            newsList: {}
        };
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    methods: {
        getAllNews() {
            axios.get("/news/all")
                .then((response) => {
                    this.newsList = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("New List API Error", error);
                });
        },
        
        getNewsDetail() {
            axios.get("/news/" + this.$route.params.id)
                .then((response) => {
                    this.news = response.data;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("New Detail API Error", error);
                });
        },
    },

    filters: {
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    mounted() {
        this.getAllNews();
        this.getNewsDetail();
        fetchNotificationCount();
    }
};
